import { ArrowLeft, LockKeyhole, MessageCircleMore } from "lucide-react";
import { useState } from "react";

import { apiRequest } from "./api.js";

function AuthPanel({ onAuthenticated, onBack, initialError = "" }) {
  const isLocal = ["127.0.0.1", "localhost"].includes(window.location.hostname);
  const [mode, setMode] = useState("login");
  const [form, setForm] = useState({ loginId: "", displayName: "", password: "" });
  const [error, setError] = useState(initialError);
  const [submitting, setSubmitting] = useState(false);

  async function submit(event) {
    event.preventDefault();
    setError("");
    setSubmitting(true);
    try {
      const payload = await apiRequest(`/api/auth/${mode}`, { method: "POST", body: JSON.stringify(form) });
      onAuthenticated(payload.user);
    } catch (requestError) {
      setError(requestError.message);
    } finally {
      setSubmitting(false);
    }
  }

  return (
    <main className="auth-page">
      <button className="auth-back" type="button" onClick={onBack}><ArrowLeft size={17} /> 홈으로</button>
      <section className="auth-card">
        <span className="auth-mark"><MessageCircleMore size={25} /></span>
        <span className="auth-eyebrow"><LockKeyhole size={14} /> 안전한 대화 시작</span>
        <h1>{mode === "login" ? "다시 만나 반가워요" : "첫 대화 공간을 만들어요"}</h1>
        <p>{mode === "login" ? "내 아이디로 로그인해 대화를 이어가세요." : "아이디와 표시 이름만으로 바로 시작할 수 있습니다."}</p>
        <form onSubmit={submit}>
          <label><span>아이디</span><input autoComplete="username" value={form.loginId} onChange={(event) => setForm({ ...form, loginId: event.target.value })} placeholder="영문·숫자 3자 이상" required /></label>
          {mode === "register" && <label><span>표시 이름</span><input autoComplete="nickname" value={form.displayName} onChange={(event) => setForm({ ...form, displayName: event.target.value })} placeholder="대화에 표시할 이름" required /></label>}
          <label><span>비밀번호</span><input type="password" autoComplete={mode === "login" ? "current-password" : "new-password"} value={form.password} onChange={(event) => setForm({ ...form, password: event.target.value })} placeholder={mode === "login" && isLocal ? "로컬 계정은 비워둘 수 있습니다" : "8자 이상"} required={mode === "register" || !isLocal} /></label>
          {error && <p className="form-error" role="alert">{error}</p>}
          <button className="auth-submit" type="submit" disabled={submitting}>{submitting ? "처리 중…" : mode === "login" ? "로그인" : "회원가입"}</button>
        </form>
        <button className="auth-mode" type="button" onClick={() => { setMode(mode === "login" ? "register" : "login"); setError(""); }}>
          {mode === "login" ? "처음이신가요? 회원가입" : "이미 계정이 있나요? 로그인"}
        </button>
      </section>
    </main>
  );
}

export default AuthPanel;
